import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "row justify--space-between align--end",
  style: {"margin":"6px 8px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "flex sm4 md3" }
const _hoisted_4 = { class: "mdo-select" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "resultData_overall" }, "Resultado", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "flex sm4 md3" }
const _hoisted_8 = { class: "mdo-select" }
const _hoisted_9 = { for: "status" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "flex sm4 md3" }
const _hoisted_12 = { class: "mdo-select mb-1" }
const _hoisted_13 = { for: "status12Med" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "mdo-select" }
const _hoisted_16 = { for: "sort" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "flex sm4 md3" }
const _hoisted_19 = {
  key: 0,
  class: "mdo-select mb-1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "accounts" }, "Contas", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Todos ", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 1,
  class: "mdo-select mb-1"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "campaign" }, "Campanha", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Todos ", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 2,
  class: "mdo-select"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "agent" }, "Agente", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Todos ", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "flex sm4 md3" }
const _hoisted_32 = {
  class: "flex sm8 md9 align-self-baseline",
  style: {"display":"flex"}
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Baixar CSV ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Baixar Excel ")
const _hoisted_35 = { style: {"max-width":"200px","white-space":"break-spaces"} }
const _hoisted_36 = { style: {"max-width":"200px","white-space":"break-spaces"} }
const _hoisted_37 = { class: "row gap-2 align--center justify--center" }
const _hoisted_38 = { class: "mr-2" }
const _hoisted_39 = { style: {"width":"100px","white-space":"break-spaces"} }
const _hoisted_40 = { class: "text--center" }
const _hoisted_41 = { class: "text--center" }
const _hoisted_42 = { class: "text--center" }
const _hoisted_43 = { class: "text-secondary" }
const _hoisted_44 = { class: "text--center" }
const _hoisted_45 = { class: "text--secondary" }
const _hoisted_46 = { class: "text--center" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "flex xs12" }
const _hoisted_49 = { class: "row pa-2" }
const _hoisted_50 = { class: "flex xs12 sm5" }
const _hoisted_51 = {
  key: 0,
  class: "row"
}
const _hoisted_52 = { class: "flex xs12 pa-2" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "column" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode()
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-xmark mr-1" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode()
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { key: 2 }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode()
const _hoisted_66 = { key: 3 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-xmark" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode()
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { key: 4 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode()
const _hoisted_73 = { key: 5 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-xmark mr-1" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode()
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "flex xs12 pa-2" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("b", null, "ID:", -1)
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = {
  key: 0,
  class: "row"
}
const _hoisted_83 = {
  key: 1,
  class: "row"
}
const _hoisted_84 = {
  key: 2,
  class: "row"
}
const _hoisted_85 = {
  key: 3,
  class: "row"
}
const _hoisted_86 = {
  key: 4,
  class: "row"
}
const _hoisted_87 = { class: "row" }
const _hoisted_88 = {
  key: 1,
  class: "row"
}
const _hoisted_89 = { class: "flex xs12 pa-2" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = {
  key: 2,
  class: "row"
}
const _hoisted_94 = { class: "flex xs12 pa-2" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = {
  key: 0,
  class: "row"
}
const _hoisted_100 = { class: "row align--end align-content--center" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" Fechar ")
const _hoisted_102 = { class: "flex xs12 sm7" }

import {ExamService} from "@/codes/services/ExamService";
import {
  Account,
  BookTypeEnum,
  Data12MedStatusEnum,
  Exam,
  ExamConditionAndInput,
  ExamSearchInput,
  ExamStatusEnum,
  ResultTestEnum,
  RoleEnum,
  SortExamInput,
  SortOrderEnum
} from "@/codes/gen/types";
import {ReactiveData} from "@/codes/types/MDOTypes";
import {DEFAULT_ITEMS_PER_PAGE, ROUTE_NAMES, VUEX_ACTIONS} from "@/codes/util/constants";
import {onMounted, onUnmounted, reactive, ref} from "vue";
import {useI18n} from "vue-i18n";
import {calculatePageCount, hasRoles, openWhats} from "@/codes/util/functions";

import Swal from "sweetalert2";
import {CampaignService} from "@/codes/services/CampaignService";
import {AgentService} from "@/codes/services/AgentService";
import store from "@/store";
import {AccountService} from "@/codes/services/AccountService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const i18n = useI18n();
const service = new ExamService();
const loadingExams = ref(false);
let pageLoaded = 0;
let page = 1;
const pageCount = ref(1);
const itemsPerPage = ref(DEFAULT_ITEMS_PER_PAGE);
const exams = reactive<ReactiveData<any[]>>({ data: [] as any[] });
const campaigns = reactive<ReactiveData<any[]>>({ data: [
    {name: 'Todos', id: null}
  ] as any[] });
const agents = reactive<ReactiveData<any[]>>({ data: [{name: 'Todos', id: null}] as any[] });
const accounts = reactive<ReactiveData<Account[]>>({ data: [] as Account[] });
const examStatus = reactive({ data: [{text: 'Todos', value: null}] as any });
const examStatus12Med = reactive({ data: [{text: 'Todos', value: null}] as any });
const optionsResult = reactive({ data: [{text: 'Todos', value: null}] as any });

const showDetail = ref(false);
const loadingDetail = ref(false);
const detailData = reactive<ReactiveData<Exam>>({ data: {} as Exam });
const items12Med = reactive<ReactiveData<any[]>>({ data: [] as any[] });

const linkDownloadCSV = ref('');
const linkDownloadXLS = ref('');
const filterParams = ref<ExamSearchInput>({ page: page, perPage: itemsPerPage.value, sort: { createdAt: SortOrderEnum.Desc } });
let interval: number | null | undefined | any = null;


let isFranchiseeManger = hasRoles([RoleEnum.FranchiseeManger]);
let isConsultantOrAdmin = hasRoles([RoleEnum.Consultant, RoleEnum.Webmaster]);


const headers = reactive({ data: [
  { key: 'campaignName', label: i18n.t('campaign.title') },
  { key: 'agentName', label: i18n.t('agent.title') },
  { key: 'clientName', label: i18n.t('client.title') },
  { key: 'clientWhatsapp', label: i18n.t('register.whatsapp'), width: 150 },
  { key: 'type', label: i18n.t('voucher.exam.from'), width: 75 },
  { key: 'overall', label: i18n.t('voucher.exam.resultType'), width: 50 },
  { key: 'status', label: i18n.t('voucher.exam.status'), width: 75 },
  { key: 'status12Med', label: i18n.t('12med.status12Med'), width: 75 },
  { key: 'voucher', label: i18n.t('voucher.title'), width: 75 },
  { key: 'date', label: i18n.t('voucher.exam.createdAt'), width: 75 },
  { key: 'actions', label:'Ver', width: 75 },
] as any[] });


const columns12Med = [
  { key: 'data', label: 'Data', width: 25},
  { key: 'medic', label: 'Médico', width: 25 },
  { key: 'status', label: 'Status', width: 25 },
]

const maskWhatsApp = (whats: string | undefined) => {
  if(!whats){
    return ''
  }
  return `${whats.substring(0, 2)}*****${whats.slice(-4)}`
}
const actionWhatsApp = (whats: string | undefined) => {
  if(!whats){
    return ''
  }
  const clearedWhats = whats.trim();
  if(clearedWhats.length < 13){
    return `55${clearedWhats}`
  }
  return clearedWhats
}

const tranformExamData = (exam) => {
  return {
    id: exam.id,
    campaignName: exam.campaign.name,
    type: exam.type,
    overall: exam.resultData?.overall,
    agentName: exam.agent.name,
    clientName: exam.client.name,
    clientWhatsapp: maskWhatsApp(exam.client.whatsapp),
    clientWhatsappAction: actionWhatsApp(exam.client.whatsapp),
    status: exam.status,
    status12Med: exam.info12Med?.statusText,
    voucher: exam.voucher,
    date: exam.createdAt.transform
  }
}


const filterExams = async function(filter: ExamSearchInput) {

  exams.data = [];

  loadingExams.value = true;
  const examsEdge = await service.getAll(filter);
  if (examsEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, examsEdge.pagination?.total ?? 1);
    exams.data =  examsEdge.edges.map((exam) => tranformExamData(exam));
    pageLoaded = page;

    linkDownloadXLS.value = examsEdge.linkDownloadXLS as string;
    linkDownloadCSV.value = examsEdge.linkDownloadCSV as string;
  }
  loadingExams.value = false;
}

const refetchExams = async function() {

  const examsEdge = await service.getAll(filterParams.value);
  if (examsEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, examsEdge.pagination?.total ?? 1);
    exams.data =  examsEdge.edges.map((exam) => tranformExamData(exam));
    pageLoaded = page;

    linkDownloadXLS.value = examsEdge.linkDownloadXLS as string;
    linkDownloadCSV.value = examsEdge.linkDownloadCSV as string;
  }

}

const startRefetch = function (){
  interval = setInterval(refetchExams, 5000)
}



const loadExams = async function() {
  filterExams({ page: page, perPage: itemsPerPage.value, sort: { createdAt: SortOrderEnum.Desc } })
}

// --------- FILTER
const examSort = reactive({ data: [
    {
      text: 'Data decrescente',
      value: { createdAt: SortOrderEnum.Desc }
    },
    {
      text: 'Data crescente',
      value: { createdAt: SortOrderEnum.Asc }
    },
    {
      text: 'Status',
      value: { status: SortOrderEnum.Desc }
    },
    {
      text: 'Status12Med',
      value: { status12Med: SortOrderEnum.Desc }
    }
  ] as any });

const filter = reactive<ReactiveData<ExamSearchInput>>({
  data: {
    and: {
      status: undefined,
      status12Med: undefined,
      resultData_overall: undefined,
      account: undefined,
      campaign: undefined,
      agent: undefined,
    } as ExamConditionAndInput,
    sort: examSort.data[0].value as SortExamInput
  } as ExamSearchInput
});


for (const a of Object.values(ExamStatusEnum)) {
  const t = i18n.t(`enums.${a}`);
  examStatus.data.push({ text: t, value: a });
}

for (const a of Object.values(Data12MedStatusEnum)) {
  const t = i18n.t(`enums.12Med.${a}`);
  examStatus12Med.data.push({ text: t, value: a });
}

for (const a of Object.values(ResultTestEnum)) {
  const t = i18n.t(`enums.${a}`);
  optionsResult.data.push({ text: t, value: a });
}

const executeFilter = function() {

  let hasFilter = false;
  const f: ExamSearchInput = {
    and: {} as ExamConditionAndInput,
    sort: examSort.data[0].value,
  };

  if (!f.and) {
    return;
  }

  if (filter.data.and?.status) {
    hasFilter = true;
    f.and.status = filter.data.and.status;
  }else if(f.and.status){
    delete f.and.status
  }

  if (filter.data.and?.status12med) {
    hasFilter = true;
    f.and.status12med = filter.data.and.status12med;
  }else if(f.and.status12med){
    delete f.and.status12med
  }

  if (filter.data.and?.resultData_overall) {
    hasFilter = true;
    f.and.resultData_overall = filter.data.and.resultData_overall;
  }else if(f.and.resultData_overall){
    delete f.and.resultData_overall
  }

  if (filter.data.and?.account) {
    hasFilter = true;
    f.and.account = filter.data.and.account;
  }else if(f.and.account){
    delete f.and.account
  }

  if (filter.data.and?.campaign) {
    hasFilter = true;
    f.and.campaign = filter.data.and.campaign;
  }else if(f.and.campaign){
    delete f.and.campaign
  }

  if (filter.data.and?.agent) {
    hasFilter = true;
    f.and.agent = filter.data.and.agent;
  }else if(f.and.agent){
    delete f.and.agent
  }

  if (filter.data.onlyLeads) {
    hasFilter = true;
    f.onlyLeads = true;
  }else {
    delete f.onlyLeads;
  }

  if (filter.data.sort) {
    hasFilter = true;
    f.sort = filter.data.sort;
  }else{
    f.sort = { createdAt: SortOrderEnum.Desc };
  }



  if (hasFilter) {
    filterParams.value = f;
    filterExams(f);
  } else {
    Swal.fire({
      title: i18n.t("form.noFilterTitle"),
      text: i18n.t("form.noFilterText")
    })
  }
}
// --------- END FILTER

const loadCampaigns = async function() {
  campaigns.data = [];

  const serviceCampaigns = new CampaignService();
  const campaignsEdge = await serviceCampaigns.getToOptions();
  if (campaignsEdge) {
    campaigns.data =  campaignsEdge.edges;
  }
}

const loadAccounts = async function() {
  accounts.data = [];

  const service = new AccountService();

  const accountsEdge = await service.getAll({});
  if (accountsEdge) {
    accounts.data = accountsEdge.edges;
  }
}

const loadAgents = async function() {
  agents.data = [];

  const serviceAgents = new AgentService();
  const agentsEdge = await serviceAgents.getToOptions();
  if (agentsEdge) {
    agents.data =  agentsEdge.edges;
  }
}

const loadDependencys = function (){

  if(isFranchiseeManger){
    loadCampaigns();
    loadAgents();
  }


  if(isConsultantOrAdmin){
    loadAccounts();
  }
}

const cleanFilter = function() {
  filter.data = {
    and: {
      status: undefined,
      status12Med: undefined,
      resultData_overall: undefined,
    } as ExamConditionAndInput,
    sort: examSort.data[0].value as SortExamInput,
    onlyLeads: false,
  } as ExamSearchInput

  filterParams.value = { page: page, perPage: itemsPerPage.value, sort: { createdAt: SortOrderEnum.Desc } };

  const elResult = document.getElementById("selResultado");
  if(elResult){
    elResult.selectedIndex = 0;
  }

  const elStatus = document.getElementById("selStatus");
  if(elStatus){
    elStatus.selectedIndex = 0;
  }


  loadExams()
}


const detail = async function(id: string) {
  showDetail.value = true;
  loadingDetail.value = true;

  const result = await service.detail(id);
  if (result) {
    detailData.data = result;
    items12Med.data = !result.info12Med? [] : result.info12Med?.data.map(r => (
        {
          data: r.date.transform,
          medic: r.agent?.name ? `${r.agent?.name} - ${r.agent?.crm || ''}` : '',
          status: r.statusText || ''
        }
    ))
  }
  loadingDetail.value = false;
}

const showDetailsButton = function(exam: Exam) {
  return exam.status === ExamStatusEnum.Finished || exam.status === ExamStatusEnum.Converted;
}

const examResultOverralStyle = function(result: ResultTestEnum) {
  switch (result) {
    case ResultTestEnum.Bad:
      return "color: var(--va-danger)";
    case ResultTestEnum.Medium:
      return "color: var(--va-warning)";
    case ResultTestEnum.Good:
      return "color: var(--va-success)";
    default:
      return "";
  }
}
const examTypeStyle = function(type: BookTypeEnum) {
  switch (type) {
    case BookTypeEnum.Outside:
      return "color: var(--va-success)";
    case BookTypeEnum.Inside:
      return "color: var(--va-warning)";
    default:
      return "";
  }
}

const examStatusStyle = function(type: ExamStatusEnum) {
  switch (type) {
    case ExamStatusEnum.Abandoned:
      return " background-color: var(--va-danger)";
    case ExamStatusEnum.Converted:
      return "background-color: var(--va-success)";
      case ExamStatusEnum.Initiated:
      return "background-color: var(--va-warning); color: #000";
    case ExamStatusEnum.Finished:
      return "background-color: var(--va-info)";
    default:
      return "";
  }
}

store.subscribeAction({
  after: (action) => {
    if (action.type === VUEX_ACTIONS.setUserInfo) {

      isFranchiseeManger = hasRoles([RoleEnum.FranchiseeManger]);
      isConsultantOrAdmin = hasRoles([RoleEnum.Consultant, RoleEnum.Webmaster]);
      loadDependencys();
    }
  }
});

const stoptInterval = function (){
  clearInterval(interval);
  interval = null;
}

const onPageChanged = function(newPage: number) {
  page = newPage;
  loadExams();
}

onMounted(() => {
  loadExams();
  loadDependencys();
  startRefetch();
});

onUnmounted(() => {
stoptInterval();
});




return (_ctx: any,_cache: any) => {
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_data_table = _resolveComponent("va-data-table")!
  const _component_base_list = _resolveComponent("base-list")!
  const _component_va_navbar_item = _resolveComponent("va-navbar-item")!
  const _component_va_navbar = _resolveComponent("va-navbar")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_base_list, {
        page: _unref(page),
        "page-count": pageCount.value,
        "current-route": _unref(ROUTE_NAMES).exams,
        "page-loaded": _unref(pageLoaded),
        "show-delete": false,
        "show-new": false,
        "has-filter": true,
        onPageChanged: onPageChanged
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_va_accordion, { style: {"max-width":"70%"} }, {
              default: _withCtx(() => [
                _createVNode(_component_va_collapse, {
                  header: _ctx.$t('list.filters')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_card_content, { style: {"background-color":"var(--va-collapse-header-content-background-color)"} }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                  _hoisted_5,
                                  _withDirectives(_createElementVNode("select", {
                                    id: "selResultado",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(filter).data.and.resultData_overall = $event)),
                                    name: "resultData_overall",
                                    multiple: ""
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsResult).data, (op) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: op.value,
                                        value: op.value
                                      }, _toDisplayString(op.text), 9, _hoisted_6))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _unref(filter).data.and.resultData_overall]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('book.status')), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    id: "selStatus",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(filter).data.and.status = $event)),
                                    name: "status",
                                    multiple: ""
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(examStatus).data, (op) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: op.value,
                                        value: op.value
                                      }, _toDisplayString(op.text), 9, _hoisted_10))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _unref(filter).data.and.status]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('12med.status12Med')), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(filter).data.and.status12med = $event)),
                                    name: "status12Med"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(examStatus12Med).data, (op) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: op.value,
                                        value: op.value
                                      }, _toDisplayString(op.text), 9, _hoisted_14))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _unref(filter).data.and.status12med]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('list.sort')), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(filter).data.sort = $event)),
                                    name: "sort"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(examSort).data, (op) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: op.value,
                                        value: op.value
                                      }, _toDisplayString(op.text), 9, _hoisted_17))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _unref(filter).data.sort]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                (_unref(isConsultantOrAdmin))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _hoisted_20,
                                      _withDirectives(_createElementVNode("select", _mergeProps({
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(filter).data.and.account = $event)),
                                        name: "accounts"
                                      }, _ctx.field), [
                                        _hoisted_21,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accounts).data, (op) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: op.id,
                                            value: op.id
                                          }, _toDisplayString(op.name), 9, _hoisted_22))
                                        }), 128))
                                      ], 16), [
                                        [_vModelSelect, _unref(filter).data.and.account]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_unref(isFranchiseeManger))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _hoisted_24,
                                      _withDirectives(_createElementVNode("select", _mergeProps({
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(filter).data.and.campaign = $event)),
                                        name: "campaign"
                                      }, _ctx.field), [
                                        _hoisted_25,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campaigns).data, (op) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: op.id,
                                            value: op.id
                                          }, _toDisplayString(op.name), 9, _hoisted_26))
                                        }), 128))
                                      ], 16), [
                                        [_vModelSelect, _unref(filter).data.and.campaign]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_unref(isFranchiseeManger))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _hoisted_28,
                                      _withDirectives(_createElementVNode("select", _mergeProps({
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(filter).data.and.agent = $event)),
                                        name: "agent"
                                      }, _ctx.field), [
                                        _hoisted_29,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agents).data, (op) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: op.id,
                                            value: op.id
                                          }, _toDisplayString(op.name), 9, _hoisted_30))
                                        }), 128))
                                      ], 16), [
                                        [_vModelSelect, _unref(filter).data.and.agent]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_va_checkbox, {
                                  modelValue: _unref(filter).data.onlyLeads,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(filter).data.onlyLeads = $event)),
                                  label: "Apenas Leads"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_va_button, {
                                  color: "warning",
                                  onClick: cleanFilter
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('list.cleanFilter')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_va_button, {
                                  color: "info",
                                  class: "ml-3",
                                  onClick: executeFilter
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('list.executeFilter')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              color: "info",
              href: linkDownloadCSV.value,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["href"]),
            _createVNode(_component_va_button, {
              class: "ml-3",
              color: "warning",
              href: linkDownloadXLS.value,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _createVNode(_component_va_data_table, {
            items: _unref(exams).data,
            columns: _unref(headers).data,
            "sticky-header": "",
            loading: loadingExams.value,
            "no-data-html": "Sem resultados",
            style: _normalizeStyle({
          '--va-data-table-scroll-table-color': 'var(--va-divider)',
        })
          }, {
            "cell(campaignName)": _withCtx(({ rowData }) => [
              _createElementVNode("span", _hoisted_35, _toDisplayString(rowData.campaignName), 1)
            ]),
            "cell(clientName)": _withCtx(({ rowData }) => [
              _createElementVNode("span", _hoisted_36, _toDisplayString(rowData.clientName), 1)
            ]),
            "cell(status)": _withCtx(({ rowData }) => [
              _createVNode(_component_va_chip, {
                color: "info",
                style: _normalizeStyle([{"width":"100px","font-size":"12px"}, examStatusStyle(rowData.status)])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`enums.${rowData.status}`)), 1)
                ]),
                _: 2
              }, 1032, ["style"])
            ]),
            "cell(clientWhatsapp)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, _toDisplayString(rowData.clientWhatsapp), 1),
                (rowData.clientWhatsappAction)
                  ? (_openBlock(), _createBlock(_component_va_button, {
                      key: 0,
                      style: {"background-color":"var(--va-success)"},
                      size: "small",
                      round: "",
                      icon: "fas fa-brands fa-whatsapp",
                      onClick: ($event: any) => (_unref(openWhats)(rowData.clientWhatsappAction, 'Olá, você fez um teste rápido de visão, percebemos que teve resultado ruim e gostaríamos de lhe ajudar.'))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell(status12Med)": _withCtx(({ rowData }) => [
              _createElementVNode("small", _hoisted_39, _toDisplayString(rowData.status12Med), 1)
            ]),
            "cell(type)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_40, [
                (rowData.type === _unref(BookTypeEnum).Outside)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fa-solid fa-qrcode success",
                      style: _normalizeStyle(examTypeStyle(rowData.type))
                    }, null, 4))
                  : _createCommentVNode("", true),
                (rowData.type === _unref(BookTypeEnum).Inside)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: "fa-solid fa-share-nodes warning",
                      style: _normalizeStyle(examTypeStyle(rowData.type))
                    }, null, 4))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell(overall)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_41, [
                (rowData.overall)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fa-solid fa-circle danger",
                      style: _normalizeStyle(examResultOverralStyle(rowData.overall))
                    }, null, 4))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell(voucher)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_42, [
                _createTextVNode(_toDisplayString(rowData.voucher ? rowData.voucher.name : '') + " ", 1),
                _createElementVNode("small", _hoisted_43, _toDisplayString(rowData.voucher ? rowData.voucher.discountLabel : '') + " - " + _toDisplayString(rowData.voucher && rowData.voucher.usedAt ? rowData.voucher.usedAt.tranform : ''), 1)
              ])
            ]),
            "cell(date)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("small", _hoisted_45, _toDisplayString(rowData.date), 1)
              ])
            ]),
            "cell(actions)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_46, [
                (showDetailsButton(rowData))
                  ? (_openBlock(), _createBlock(_component_va_button, {
                      key: 0,
                      size: "small",
                      icon: "fas fa-eye",
                      class: "",
                      onClick: ($event: any) => (detail(rowData.id))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["items", "columns", "loading", "style"])
        ]),
        _: 1
      }, 8, ["page", "page-count", "current-route", "page-loaded"])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: showDetail.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (showDetail.value = $event)),
      class: "exam-detail",
      blur: "",
      "no-dismiss": "",
      "no-padding": "",
      "hide-default-actions": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_va_navbar, {
              color: "info",
              shape: "",
              class: "mb-2"
            }, {
              left: _withCtx(() => [
                _createVNode(_component_va_navbar_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", {
                      class: "display-3",
                      style: _normalizeStyle({
                    'color': 'var(--va-white)',
                  })
                    }, _toDisplayString(_ctx.$t('voucher.exam.details')), 5)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            (_unref(detailData).data.client)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_va_card, {
                      stripe: "",
                      "stripe-color": "success"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('client.title')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_va_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('register.name')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.client.name), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('register.whatsapp')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.client.whatsapp), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              (_unref(detailData).data.client.camera)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                    _hoisted_57,
                                    _hoisted_58,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.usedCamera')), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_59, [
                                    _hoisted_60,
                                    _hoisted_61,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.notUsedCamera')), 1)
                                  ])),
                              _hoisted_62,
                              (_unref(detailData).data.client.acceptedReceiveMessage)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                                    _hoisted_64,
                                    _hoisted_65,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('client.acceptNotifications')), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_66, [
                                    _hoisted_67,
                                    _hoisted_68,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('client.notAcceptNotifications')), 1)
                                  ])),
                              _hoisted_69,
                              (_unref(detailData).data.client.accepted12med)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                                    _hoisted_71,
                                    _hoisted_72,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.accepted12med')), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_73, [
                                    _hoisted_74,
                                    _hoisted_75,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.acceptedNot12med')), 1)
                                  ]))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_va_card, {
                  stripe: "",
                  "stripe-color": "success"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('voucher.exam.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("label", null, [
                            _hoisted_79,
                            _createTextVNode(" " + _toDisplayString(_unref(detailData).data.id), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("label", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.inputType')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`enums.${_unref(detailData).data.type}`)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("label", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.from')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`enums.${_unref(detailData).data.from}`)), 1)
                          ])
                        ]),
                        (_unref(detailData).data.createdAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('register.startedAt')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.createdAt.transform), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(detailData).data.updatedAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('register.finishedAt')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.updatedAt.transform), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(detailData).data.account)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('account.title')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.account.name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(detailData).data.campaign)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('campaign.title')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.campaign.name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(detailData).data.agent)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('agent.title')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.agent.name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("label", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.status')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`enums.${_unref(detailData).data.status}`)), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            (_unref(detailData).data.info12Med)
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_component_va_card, {
                      stripe: "",
                      "stripe-color": "success"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('12med.title')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_va_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("label", _hoisted_91, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('12med.status')) + ":", 1),
                                (_unref(detailData).data.info12Med?.statusText)
                                  ? (_openBlock(), _createBlock(_component_va_chip, {
                                      key: 0,
                                      color: "info",
                                      style: {"width":"100%","font-size":"12px","margin":"0 12px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(detailData).data.info12Med?.statusText || ''), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              _createVNode(_component_va_data_table, {
                                items: _unref(items12Med).data,
                                columns: columns12Med,
                                class: "table12Med cell-border"
                              }, null, 8, ["items"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(detailData).data.voucher)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _createVNode(_component_va_card, {
                      stripe: "",
                      "stripe-color": "success"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('voucher.title')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_va_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('register.name')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.voucher.name), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.codes.code')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.voucher.code), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.discount')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.voucher.discountLabel), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.exam.status')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_unref(detailData).data.voucher.usedAt ? 'Usado' : 'Não resgatado'), 1)
                              ])
                            ]),
                            (_unref(detailData).data.voucher.usedAt)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                  _createElementVNode("label", null, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('voucher.usedAt')) + ":", 1),
                                    _createTextVNode(" " + _toDisplayString(_unref(detailData).data.voucher.usedAt), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_100, [
              _createVNode(_component_va_button, {
                class: "mx-auto px-4",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (showDetail.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_101
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createVNode(_component_va_image, {
              ratio: 0.72,
              src: _unref(detailData).data.resultImage
            }, null, 8, ["ratio", "src"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})